import React from "react";
import "./Item.css";

const ItemRowClubMfl = ({ c }) => {
  return (
    <div className={"Item d-flex flex-row flex-fill"} style={{ backgroundColor: "transparent", cursor: "default" }}>
      <div className="flex-fill">
        <div className={`d-flex flex-row flex-fill pb-1 pb-md-0`}>
          <div className={`d-flex`}>
            <img
              src={`https://d13e14gtps4iwl.cloudfront.net/u/clubs/${c.id}/logo.webp`}
              alt={`${c.id} logo`}
              style={{ width: "15px", height: "15px", marginTop: "3px", marginRight: "3px" }}
            />
            {c.name ? c.name : ""}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ItemRowClubMfl;
